import localforage from 'localforage';
// src is a alias. see client/build/webpack.base.conf.js
import { userIdStorageKey } from '@/config';
import { isEmpty } from 'lodash';
import * as TYPES from './mutations-types';
import api from '../api';

const attemptLogin = ({ dispatch }, payload) =>
  api.postLogin(payload)
    .then((user) => {
      dispatch('setUser', user)
      return user // keep promise chain
    });

const checkUser = ({ dispatch, state }) => {
  if (!isEmpty(state.user)) {
    return Promise.resolve(state.user);
  }
  dispatch('loadUser');
};

const logout = ({ dispatch }) => {
  api.logoutApp().then((response) => {
    window.location = response.url_logout;
  });
  // call actions
  return Promise.all([
    dispatch('setUser', {})
  ]);
};

const setUser = ({ commit }, user) => {
  // Commit the mutations
  commit(TYPES.SET_USER, user);

  const userId = user.id || '';

  localforage.setItem(userIdStorageKey, userId)

  Promise.resolve(user) // keep promise chain
};

const loadUser = ({ dispatch }) => api.loadUserData()
  // store user's data
  .then(user => dispatch('setUser', user))
  .catch(() => {
    // Process failure, delete the token
    return Promise.reject('FAIL_IN_LOAD_USER'); // keep promise chain
  });

export default {
  checkUser: checkUser,
  attemptLogin,
  logout,
  setUser,
  loadUser
};



// WEBPACK FOOTER //
// ./src/pages/auth/store/actions.js